import { render, staticRenderFns } from "./headerTitle.vue?vue&type=template&id=1aa105bc&scoped=true"
import script from "./headerTitle.vue?vue&type=script&lang=js"
export * from "./headerTitle.vue?vue&type=script&lang=js"
import style0 from "./headerTitle.vue?vue&type=style&index=0&id=1aa105bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa105bc",
  null
  
)

export default component.exports